document.addEventListener("click", function (event) {
  const chooseTrigger = event.target.closest(".choose_btn_cstm ");
  const addTrigger = event.target.closest(".addCard_btn");

  // If neither button clicked → exit
  if (!chooseTrigger && !addTrigger) return;

  event.preventDefault();

  const triggerBtn = chooseTrigger || addTrigger;
  const productCard = triggerBtn.closest(".product-card__content");
  if (!productCard) return;

  const quickAdd = productCard.querySelector("quick-add-component");
  if (!quickAdd) return;

  // USER CLICKED CHOOSE BUTTON
  if (chooseTrigger) {
    const chooseBtn = quickAdd.querySelector(".quick-add__button--choose");
    if (chooseBtn) {
      console.log("Choose button clicked");
      chooseBtn.click();
    }
  }

  // USER CLICKED ADD TO CART BUTTON
  if (addTrigger) {
    const addBtn = quickAdd.querySelector(".quick-add__button--add");
    if (addBtn) {
      console.log("Add to cart button clicked");
      addBtn.click();
    }
  }
});
document.addEventListener('DOMContentLoaded', function() {

  document.querySelectorAll('.product_description .details-content').forEach(content => {

    const textElement = content.querySelector('rte-formatter');

    if (!textElement || content.dataset.readmoreInitialized) return;

    content.dataset.readmoreInitialized = 'true';
    content.classList.add('is-collapsed');

    const btn = document.createElement('span');
    btn.className = 'read-more-toggle';
    btn.textContent = 'Read More';

    content.insertAdjacentElement('afterend', btn);

    btn.addEventListener('click', function() {

      content.classList.toggle('is-collapsed');

      btn.textContent = content.classList.contains('is-collapsed')
        ? 'Read More'
        : 'Read Less';

    });

  });

});